import { css, cx } from 'emotion';

import {
	lightGrey,
	darkGrey,
	sideBarLayout,
	headingMediumLight,
	mobileMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const subTitleStyle = cx(
	headingMediumLight,
	css({
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '16px',
			lineHeight: '18px',
		},
	})
);

export const featuredCardSectionStyle = css({
	margin: '60px 0',
	'& header': {
		marginBottom: '25px',
	},
});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	position: 'relative',
});

export const mobileFiltersStyle = sideBarLayout.mobileFilters;

export const mobileFiltersDropDownStyle = css({
	position: 'relative',
	boxShadow: 'rgba(0,0,0,0.09) 0 6px 12px 0',
	background: '#fff',
	zIndex: '3',
	padding: '20px',
});

export const mobileSearchStyle = css({
	display: 'none !important',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		display: 'block !important',
	},
});

export const rightSearchStyle = css({
	display: 'block',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		display: 'none',
	},
});

export const wrapperStyle = sideBarLayout.wrapper;

export const filtersWrapperStyle = css({
	borderBottom: `1px solid ${lightGrey}`,
});

export const filtersInnerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '74px',
	margin: '0 auto',
	padding: '0 20px',
	display: 'flex',
	justifyContent: 'flex-end',
	alignItems: 'center',

	[`@media (max-width: ${desktopMaxWidthBreakpoint}px)`]: {
		justifyContent: 'space-between',
	},

	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		justifyContent: 'flex-start',
	},

	'& [data-component=FilterDropDown]': {
		display: 'none',
		[`@media (max-width: ${desktopMaxWidthBreakpoint}px)`]: {
			display: 'block',
			marginRight: '20px',
		},
	},

	'& [data-component=SingleFieldForm]': {
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			'& input': {
				width: 'calc(100% - 46px)',
			},
		},
	},
});

export const leftStyle = sideBarLayout.leftSide(0);

export const rightStyle = sideBarLayout.rightSide(0);

export const pageControlsStyle = css({
	display: 'table',
	width: '100%',
	'& p': {
		display: 'table-cell',
		width: '100%',
		color: darkGrey,
		fontSize: '16px',
		lineHeight: '19px',
	},
	'& > div': {
		display: 'table-cell',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		'& p, & > div': {
			display: 'block',
		},
	},
});



// WEBPACK FOOTER //
// ./src/page-styles/blog-and-podcast/index.js